// Serialises a JSON-LD object for a <script type="application/ld+json">.
//
// D5: CMS rich text (descriptions, FAQ answers, bios) reached the structured
// data as raw HTML. Google reads JSON-LD strings as plain text, so tags,
// entities and {{placeholders}} are cleaned here, once, for every schema.
// "<" is escaped so a string can never close the script tag early.

const ENTITIES = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&quot;": '"',
  "&#39;": "'",
  "&apos;": "'",
  "&lt;": "<",
  "&gt;": ">",
};

export const replacePlatformPlaceholder = (text) =>
  typeof text === "string"
    ? text.replace(/\{\{\s*platform_name\s*\}\}/gi, "Tykkit")
    : text;

export const stripHtmlText = (value) => {
  if (typeof value !== "string") return value;
  let text = replacePlatformPlaceholder(value);
  if (!/[<&]/.test(text)) return text;
  text = text
    .replace(/<(br|\/p|\/li|\/h[1-6])\s*\/?>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/&(nbsp|amp|quot|#39|apos|lt|gt);/g, (m) => ENTITIES[m] ?? m);
  return text.replace(/\s+/g, " ").trim();
};

export function serializeJsonLd(schema) {
  return JSON.stringify(schema, (_key, value) => stripHtmlText(value)).replace(
    /</g,
    "\\u003c",
  );
}
